import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-primary">
      <div className="w-full px-12 lg:px-20 py-20 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {/* Coluna 1 - Branding */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6 cursor-pointer">
              <div className="flex flex-col">
                <span className="font-semibold text-sm tracking-wide text-white">GRUPO PRIME</span>
                <span className="text-[10px] tracking-[0.15em] uppercase text-white/40">Operações Corporativas</span>
              </div>
            </Link>
            <p className="text-white/50 text-sm leading-relaxed mb-6">
              Excelência em operações corporativas para eventos e empresas.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/valletprime?igsh=MTA2YnpyMnQyeTdhcQ%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-white/50 hover:bg-white/10 hover:text-white transition-all duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Coluna 2 - Empresas */}
          <div>
            <h3 className="font-semibold text-xs tracking-[0.15em] text-white uppercase mb-6">
              Empresas
            </h3>
            <div className="flex flex-col gap-3">
              <Link
                to="/empresas-do-grupo"
                className="text-white/50 text-sm hover:text-accent transition-colors duration-300 cursor-pointer"
              >
                Vallet Prime
              </Link>
              <Link
                to="/empresas-do-grupo"
                className="text-white/50 text-sm hover:text-accent transition-colors duration-300 cursor-pointer"
              >
                TR Prorok
              </Link>
            </div>
          </div>

          {/* Coluna 3 - Navegação */}
          <div>
            <h3 className="font-semibold text-xs tracking-[0.15em] text-white uppercase mb-6">
              Navegação
            </h3>
            <div className="flex flex-col gap-3">
              <Link
                to="/o-grupo"
                className="text-white/50 text-sm hover:text-accent transition-colors duration-300 cursor-pointer"
              >
                Sobre o Grupo
              </Link>
              <Link
                to="/servicos"
                className="text-white/50 text-sm hover:text-accent transition-colors duration-300 cursor-pointer"
              >
                Serviços
              </Link>
              <Link
                to="/contato"
                className="text-white/50 text-sm hover:text-accent transition-colors duration-300 cursor-pointer"
              >
                Contato
              </Link>
            </div>
          </div>

          {/* Coluna 4 - Contato */}
          <div>
            <h3 className="font-semibold text-xs tracking-[0.15em] text-white uppercase mb-6">
              Contato
            </h3>
            <a
              href="https://wa.me/5541997438126"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#20BD5A] text-white font-medium text-sm px-5 py-3 rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap mb-4"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              WhatsApp
            </a>
          </div>
        </div>

        {/* Rodapé Inferior */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            © 2025 Grupo Prime. Todos os direitos reservados.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/30 text-xs hover:text-white/50 transition-colors duration-300 cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
